import React, { Component, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import Loader from "../Shared/Loader/loader";
import { callApiWithAuthorization } from "../../API/CallApi";
import { RoleContext } from "./Context/RoleContext";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { SavingComponent, InProgressComponent } from "./SavingComponent";
import { accessMap } from "./accessMap";
import { GlobalContext } from "../../Renderers/GlobalContext"
import WorkspaceAppModelContext from "../../Context/Workspace/WorkspaceAppModelContext";
import { withTranslation } from "react-i18next";
import { getEntities, updateEntity } from "../../API/Entity/Entity";

function EntityNameCell(props) {

    const navigate = useNavigate();
    const { mutators } = useContext(WorkspaceAppModelContext);
    const { organization } = useContext(GlobalContext).state;

    function navigateToEntity() {
        if (mutators) {
            mutators.setSelectedTab(0);
            mutators.setSelectedEntity(props.dataItem);
        } else {
            navigate(`/${organization.orgName}/${props.projectName}/Entities/${props.dataItem.sysName}`)
        }
    }

    return (
        <td title={props.dataItem.name}>
            <span className="text-link" onClick={navigateToEntity}>
                {props.dataItem.name}
            </span>
        </td>
    )
}

class EntityRights extends Component {

    static contextType = RoleContext
    constructor(props) {
        super(props)
        this.state = {
            selectedRole: {},
        }
    }

    componentDidMount = async () => {
        const { dispatch } = this.context
        let entities = await this.getEntity()
        dispatch({ type: "SET_ENTITIES", payload: entities })
        dispatch({ type: "SET_ENTITY_LOADER", payload: false })
        if (entities.length > 0) {
            this.selectItem(entities[0])
        }
    }

    componentDidUpdate = async (props) => {
        const { dispatch } = this.context
        if (props.selectedRole._id && props.selectedRole._id !== this.props.selectedRole._id) {
            let entities = await this.getEntity()
            dispatch({ type: "SET_ENTITIES", payload: entities })
            dispatch({ type: "SET_ENTITY_LOADER", payload: false })
            if (entities.length > 0) {
                this.selectItem(entities[0])
            }
        }
    }

    render() {
        const { state } = this.context
        const { t } = this.props
        if (state.loadingEntities) {
            return <Loader />
        }
        return (
            <div className="pt-2 h-100">
                <Grid
                    data={state.entities.map((item) => ({
                        ...item,
                        selected: item._id === state.selectedEntity._id
                    }))}
                    onRowClick={(e) => this.selectItem(e.dataItem)}
                    style={{ maxHeight: "100%" }}
                    selectedField="selected"
                >
                    <Column field="indexId" title="#" width={40} />
                    <Column
                        title={t("grid.header.name")}
                        cell={(props) => (
                            <EntityNameCell
                                {...props}
                                projectName={this.props.projectName}
                            />
                        )}
                    />
                    <Column
                        width={170}
                        title={t("grid.header.access")}
                        cell={(props) => (
                            <td>
                                <GlobalContext.Consumer>
                                    {value => (
                                        <DropDownList
                                            disabled={
                                                props.dataItem.isUserEntity ||
                                                state.entityInProgressItems.includes(props.dataItem._id) ||
                                                value.state.subscription.rolesPermission === "Read only"
                                            }
                                            onChange={(e) => this.handlePermission(e, props.dataItem)}
                                            data={this.getAccessDataMap()}
                                            value={this.getAccessValue(props.dataItem) || ""}
                                            textField={"text"}
                                        />
                                    )}
                                </GlobalContext.Consumer>
                            </td>
                        )}
                    />
                    <Column
                        width={45}
                        title=""
                        cell={(props) => (
                            <td>
                                {state.entityInProgressItems.includes(props.dataItem._id) && <InProgressComponent />}
                                {state.entitySavedItems.includes(props.dataItem._id) && <SavingComponent />}
                            </td>
                        )}
                    />
                </Grid>
            </div>
        )
    }

    getEntity = async () => {
        let entities = await getEntities(this.props.projectId)
        if (entities.length > 0) {
            entities = entities.sort((a, b) => a.order - b.order)
            for (let i = 0; i < entities.length; i++) {
                entities[i].indexId = i + 1
            }
        } else {
            entities = []
        }
        return entities
    }

    selectItem = (dataItem) => {
        const { dispatch } = this.context
        dispatch({ type: "SET_SELECTED_ENTITY", payload: dataItem })
    }

    getAccessDataMap = () => {
        const { t } = this.props
        const accessMapData = accessMap.map(item => {
            const key = item.key.toLowerCase().split(" ").join("_")
            const text = t("dropdown_values." + key)
            return {
                ...item,
                text
            }
        })
        return accessMapData
    }

    getAccessValue = (dataItem) => {
        const { selectedRole } = this.context.state
        const accessValueData = dataItem.roleRights[selectedRole._id]
        if (!accessValueData) {
            return this.getAccessValueMap(accessMap[2])
        }
        if (
            (
                accessValueData.create &&
                accessValueData.read &&
                accessValueData.update &&
                accessValueData.delete
            ) ||
            dataItem?.isUserEntity
        ) {
            return this.getAccessValueMap(accessMap[0])
        } else if (
            !accessValueData.create &&
            accessValueData.read &&
            !accessValueData.update &&
            !accessValueData.delete
        ) {
            return this.getAccessValueMap(accessMap[1])
        } else {
            return this.getAccessValueMap(accessMap[2])
        }
    }

    getAccessValueMap(accessMapData) {
        const { t } = this.props;
        const key = accessMapData.key.toLowerCase().split(" ").join("_");
        const text = t("dropdown_values." + key);
        return {
            ...accessMapData,
            text
        };
    }

    handlePermission = async (event, dataItem) => {
        const { selectedRole } = this.context.state
        const { dispatch } = this.context
        const permission = accessMap.find(item => item.key === event.value.key)
        dispatch({ type: "ENTITY_ADD_TO_INPROGRESS", payload: dataItem._id })
        let { roleRights } = dataItem
        roleRights[selectedRole._id] = {
            ...roleRights[selectedRole._id],
            ...permission.entity
        }
        await updateEntity(dataItem._id, { roleRights: roleRights })

        if (permission.key === "Full access") {
            await this.handleFullAccessPermission(dataItem)
        }
        if (permission.key === "Read only") {
            await this.handleReadonlyPermission(dataItem)
        }
        if (permission.key === "No access") {
            await this.handleNoAccessPermission(dataItem)
        }
        dispatch({ type: "UPDATE_ENTITIES", payload: { _id: dataItem._id, properties: dataItem } })
        dispatch({ type: "ENTITY_MOVE_TO_SAVE", payload: dataItem._id })
        this.selectItem({ ...dataItem, ...permission.entity })
    }

    handleFullAccessPermission = async (element) => {
        const { dispatch, state } = this.context
        const { selectedRole } = state
        await Promise.all([
            this.UpdateAttributesBasedonEntityRight(element._id, "Edit"),
            this.UpdatePagesBasedonEntityRight(element._id, true)
        ])
        dispatch({ type: "UPDATE_ALL_ATTRIBUTES", payload: { entityPermission: "Full access", properties: { permission: "Edit", roleId: selectedRole._id } } })
        dispatch({ type: "UPDATE_ALL_PAGES", payload: { entityPermission: "Full access", properties: { access: true } } })
        dispatch({ type: "UPDATE_ALL_OTHER_RIGHTS", payload: true })
    }

    handleReadonlyPermission = async (element) => {
        const { dispatch, state } = this.context
        const { selectedRole } = state
        await Promise.all([
            this.UpdateAttributesBasedonEntityRight(element._id, "Readonly"),
            this.UpdatePagesBasedonEntityRight(element._id, true)
        ])

        await this.UpdateSpecificPageBasedonEntityRight(element._id, false, "New Record")
        await this.UpdateSpecificPageBasedonEntityRight(element._id, false, "Edit Record")

        dispatch({ type: "UPDATE_ALL_ATTRIBUTES", payload: { entityPermission: "Read only", properties: { permission: "Readonly", roleId: selectedRole._id } } })
        dispatch({ type: "UPDATE_ALL_PAGES", payload: { entityPermission: "Read only", properties: { access: true } } })
        dispatch({ type: "UPDATE_ALL_OTHER_RIGHTS", payload: true })
    }

    handleNoAccessPermission = async (element) => {
        const { dispatch, state } = this.context
        const { selectedRole } = state
        await Promise.all([
            this.UpdateAttributesBasedonEntityRight(element._id, "Hidden"),
            this.UpdatePagesBasedonEntityRight(element._id, false)
        ])
        dispatch({ type: "UPDATE_ALL_ATTRIBUTES", payload: { entityPermission: "No access", properties: { permission: "Hidden", roleId: selectedRole._id } } })
        dispatch({ type: "UPDATE_ALL_PAGES", payload: { entityPermission: "No access", properties: { access: false } } })
        dispatch({ type: "UPDATE_ALL_OTHER_RIGHTS", payload: false })
    }

    UpdateAttributesBasedonEntityRight = async (entityid, attributeValue) => {
        const { selectedRole } = this.context.state
        await callApiWithAuthorization("/api/v0/updateAttributesBasedonEntityRight", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                roleId: selectedRole._id,
                entityId: entityid,
                attributeValue: attributeValue
            })
        })
    }

    UpdatePagesBasedonEntityRight = async (entityid, pageValue) => {
        const { selectedRole } = this.context.state
        await callApiWithAuthorization("/api/v0/updatePagesBasedonEntityRight", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                roleId: selectedRole._id,
                entityId: entityid,
                pageValue: pageValue
            })
        })
    }

    UpdateSpecificPageBasedonEntityRight = async (entityid, pageValue, subPageType) => {
        const { selectedRole } = this.context.state
        await callApiWithAuthorization("/api/v0/updateSpecificPageBasedonEntityRight", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                roleId: selectedRole._id,
                entityId: entityid,
                pageValue: pageValue,
                subPageType: subPageType
            })
        })
    }
}

export default withTranslation([
    "role/objects_rights",
], {
    withRef: true,
})(EntityRights);